"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PRODUCT_BOX_STYLE_TYPE", {
  enumerable: true,
  get: function get() {
    return _ProductBox.PRODUCT_BOX_STYLE_TYPE;
  }
});
exports.ProductList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _ProductBox = require("./ProductBox");
var _ProductBoxTableHeader = require("./ProductBox/ProductBoxTable/ProductBoxTableHeader");
var _ProductBoxSkeleton = require("./ProductBoxSkeleton");
require("./ProductList.scss");
var ProductList = function ProductList(_ref) {
  var children = _ref.children,
    className = _ref.className,
    dataAttributes = _ref.dataAttributes,
    text = _ref.text,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _ProductBox.PRODUCT_BOX_STYLE_TYPE.tile : _ref$styleType;
  var ProductBoxTableHeader = ProductList.ProductBoxTableHeader;
  var rootClassName = (0, _classnames["default"])('cds-ProductList', {
    'cds-ProductList--List': styleType === _ProductBox.PRODUCT_BOX_STYLE_TYPE.list
  }, className);
  var productListTableClassName = (0, _classnames["default"])('cds-ProductList--Table', 'cds-Table--Bordered', 'cds-Table--Hoverable', 'cds-Table–-FullWidth');
  if (styleType === _ProductBox.PRODUCT_BOX_STYLE_TYPE.table) {
    return /*#__PURE__*/_react["default"].createElement("table", {
      className: productListTableClassName
    }, /*#__PURE__*/_react["default"].createElement(ProductBoxTableHeader, {
      text: text
    }), /*#__PURE__*/_react["default"].createElement("tbody", null, children));
  }
  return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), children);
};
exports.ProductList = ProductList;
ProductList.ProductBox = _ProductBox.ProductBox;
ProductList.ProductBoxSkeleton = _ProductBoxSkeleton.ProductBoxSkeleton;
ProductList.ProductBoxTableHeader = _ProductBoxTableHeader.ProductBoxTableHeader;
ProductList.config = {
  styleType: _ProductBox.PRODUCT_BOX_STYLE_TYPE
};